import { AxiosRequestConfig } from 'axios';
import {
  LoginPayloadRequestDTO,
  UnregisterPayloadRequestDTO,
  UserPayloadRequestDTO,
  ValidateEmailPayloadRequestDTO,
} from 'dtos/AuthenticationDTO';
import {
  ChangePasswordRequestDTO,
  RecoverPasswordRequestDTO,
  UnregisterEmailConfirmationDTO,
} from 'dtos/RecoverPasswordDTO';

import axios from './axios';

export const get = async (table: string, config?: AxiosRequestConfig) => {
  return await axios.get(`${table}`, config);
};

export const post = async (table: string, data: any) => {
  return await axios.post(`${table}`, data);
};

export const create = async (table: string, data: any) => {
  return await axios.post(`${table}/create`, data);
};

export const update = async (table: string, id: string, data: any) => {
  return await axios.put(`${table}/update/${id}`, data);
};

export const softDelete = async (table: string, id: string) => {
  return await axios.delete(`${table}/softdelete/${id}`);
};

export const register = async (payload: UserPayloadRequestDTO) => {
  try {
    await axios.post('auth/register', payload);
  } catch (error) {
    throw error;
  }
};

export const initiateResetPassword = async (payload: RecoverPasswordRequestDTO) => {
  return await axios.post('mail/reset-password/initiate', payload);
};

export const confirmResetPassword = async (payload: ChangePasswordRequestDTO) => {
  return await axios.post('mail/reset-password/confirm', payload);
};

export const unregisterEmailConfirmation = async (payload: UnregisterEmailConfirmationDTO) => {
  return await axios.post('mail/unregister-email-confirmation', payload);
};

export const getRelatorioVendas = async (fazendaId: number) => {
  return await axios.get(`relatorioVendas/getRelatorios/${fazendaId}`);
};

export const emailValidate = async ({ email, reToken }: ValidateEmailPayloadRequestDTO) => {
  const response = await axios.post('auth/login/primeiraEtapa', {
    user: email,
    reToken,
  });

  return response;
};

export const signIn = async ({ email, password, reToken }: LoginPayloadRequestDTO) => {
  const response = await axios.post('auth/login', {
    user: email,
    password,
    reToken,
  });

  return response;
};

export const signOut = async () => {
  return await axios.post('auth/logout');
};

export const unregister = async ({ email }: UnregisterPayloadRequestDTO) => {
  const response = await axios.post('auth/unregister', { email });

  return response;
};

export const getCEPAddress = async (cep: string) => {
  try {
    const response = await axios.get(`helper/getCEPAddress/${cep}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getClienteByCpf = async (cpf: string, role?: string) => {
  try {
    const url = `cliente/cpf/${cpf}${role ? `/${role}` : ''}`;
    const response = await axios.get(url);
    return response;
  } catch (error) {
    throw error;
  }
};

/* const disparaErro = _err => {
  if (_err.response.status === 422) {
    Swal.fire({
      title: 'ERRO',
      html: _err.response.data.reduce((acc, curr) => acc + curr + '<br>', ''),
      icon: 'error',
    })
  } else {
    console.error(_err)
  }
}
const requestApi = (method, url, params = {}, data = {}) => {
  return new Promise((resolve, reject) => {
    axios({ method, url, params, data })
      .then(response => {
        resolve(response.data)
      })
      .catch(_err => {
        disparaErro(_err)
        reject(_err.response.data)
      })
  })
} */
